import "./BulkActivation.css";

import { whereAlpha2, whereAlpha3 } from "iso-3166-1";
import queryString from "query-string";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";

import { fetchInactiveChannels } from "../../actions";

class BulkActivation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
    };

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData(state, instance) {
    const page = state.page + 1;
    this.setState({ page });
    const { channels } = this.props;
    const qstring = queryString.parse(this.props.location.search);
    if (
      !channels.pages[page] ||
      (!channels.pages[page].pending && !channels.pages[page].channels)
    ) {
      let country = undefined;
      if (qstring.country) {
        country = (whereAlpha2(qstring.country) || whereAlpha3(qstring.country))
          .alpha2;
      }
      this.props.fetchInactiveChannels(page, country);
    }
  }

  render() {
    const pageNumber = this.state.page;
    const { channels } = this.props;
    const page = channels.pages[pageNumber];
    let channelData = [];
    let loading = true;
    if (page) {
      loading = page.pending;
      channelData = page.channels;
    }

    const getRowProps = (...opts) => {
      return {
        onClick: () => {
          window.location.href = `${window.location.origin}/channel/${opts[1].original.id}`;
        },
      };
    };

    return (
      <div>
        <h2>Inactive Channels</h2>
        <ReactTable
          data={channelData}
          columns={[
            {
              Header: "Location",
              accessor: "location.name",
              style: { textAlign: "left" },
            },
            {
              Header: "Country",
              id: "country",
              style: { textAlign: "left" },
              accessor: (c) => whereAlpha2(c.location.country)?.country,
            },
          ]}
          loading={loading}
          onFetchData={this.fetchData}
          manual
          pages={100}
          defaultPageSize={20}
          showPageSizeOptions={false}
          sortable={false}
          filterable={false}
          getTrProps={getRowProps}
        />
      </div>
    );
  }
}

export default withRouter(
  connect(({ channel }) => ({ channels: channel.inactiveChannels }), {
    fetchInactiveChannels,
  })(BulkActivation)
);
